<template>
	<div class="tabs">
		<div class="tabs-mobile form-select">
			<select aria-label="Selected tab">
				<option v-for="tab in tabs">{{ tab }}</option>
			</select>
		</div>
		<div class="tabs-desktop">
			<div class="tabs-container">
				<nav>
					<a v-for="tab in tabs" :class="{'active': showing == tab}" @click="showing = tab">
						{{ tab }}
					</a>
				</nav>
			</div>
		</div>
		
		<div class="tab-content">
			<transition name="fade" mode="out-in">
				<tw-card v-for="tab in tabs" :key="'tab_'+tab" v-if="showing == tab" :header="false" :footer="false">
					<template v-slot:content>
						<h1 class="tab-title">{{ tab }}</h1>
						<slot :name="tab" :class="tab+'_tab'" ></slot>
					</template>
				</tw-card>
			</transition>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'navigation.tabs',
		props: {
			tabs: {
			  type: Array,
			  default: []
			}
		},
		data() {
			return {
				showing: false,
			}
		},
		mounted() {
			// always have first tab selected
			this.showing = this.tabs[0];
		}
	}
</script>